import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#03062B',
                secondary: '#0A65BB',
                accent: '#FFFF05',
                error: '#6E1806'
            },
            dark: {
                primary: '#03062B',
            },
        },
    },
});
